import { OfferT } from "@private/offers/domain";
import { PageAttr } from "@shared/domain/entities";
import { offerKeys } from "../../services";
import { useCallback } from "react";
import { InfiniteData, useQueryClient } from "@tanstack/react-query";

const updateBlockedOffersData = (
  prevData: InfiniteData<PageAttr<OfferT>>,
  updatedApproval: OfferT
): InfiniteData<PageAttr<OfferT>> =>
  prevData?.pages
    ? {
        ...prevData,
        pages: prevData.pages.map((page) => ({
          ...page,
          data: page.data.map((approval) => {
            return approval.approval_id === updatedApproval.approval_id
              ? {
                  ...approval,
                  blocking_approval_start_date:
                    updatedApproval.blocking_approval_start_date,
                  blocking_approval_user:
                    updatedApproval.blocking_approval_user,
                  offer_is_being_blocked:
                    updatedApproval.offer_is_being_blocked,
                }
              : approval;
          }),
        })),
      }
    : prevData;

const useUpdateBlockedOffers = (): ((data: OfferT) => void) => {
  const queryClient = useQueryClient();

  const updateBlockedOffers = useCallback(
    (offer: OfferT) => {
      queryClient.setQueriesData<InfiniteData<PageAttr<OfferT>>>(
        { queryKey: offerKeys.bothList() },
        (prevData) =>
          prevData ? updateBlockedOffersData(prevData, offer) : undefined
      );
    },
    [queryClient]
  );

  return updateBlockedOffers;
};

export { useUpdateBlockedOffers };
